import { Status, statusConfig } from "@modules/company/constants/statusConfig";

type StatusBadgeProps = {
  status: Status;
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const statusConfigValue = statusConfig[status];

  if (!statusConfigValue) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-md">
        <span className="font-medium text-zinc-500">Unknown Status</span>
      </div>
    );
  }

  const { label, icon: Icon, color, fillColor, strokeColor, iconClassName } = statusConfigValue;

  return (
    <div className={`flex items-center gap-2 px-3 py-2 rounded-md`}>
      <Icon className={`w-6 h-6 ${iconClassName}`} fill={fillColor} stroke={strokeColor} />
      <span className={`font-mediu ${color}`}>{label}</span>
    </div>
  );
};

export default StatusBadge;
